import React, { useEffect, useState } from 'react'
import Axios from 'axios'
import { parse, format } from 'date-fns'
import Table from '../table'
import DataLayout from '../data-layout'

const RevenueByObjectCode = ({
  match: {
    params: { year, lineNo, objCode }
  },
  location
}) => {
  const [data, setData] = useState([])

  useEffect(() => {
    const loadData = async () => {
      const result = await Axios.get(`/GetRevenue/${year}/${lineNo}/${objCode}`)
      const _data = result.data.map(d => ({
        name: d.Description.trim(),
        date: format(parse(d.Date, 'MM/dd/yyyy', new Date()), 'yyyy-MM-dd'),
        fund: d.FundName,
        nameColumn: 'Revenue Category',
        data: d.Amount
      }))
      setData(_data.sort((a, b) => a.date.localeCompare(b.date)))
    }

    loadData()
  }, [lineNo, location.search, objCode, year])

  return (
    <DataLayout year={year}>
      <Table
        data={{
          headers: [
            {
              title: 'Description',
              dataKey: 'name'
            },
            {
              title: 'Date',
              dataKey: 'date'
            },
            {
              title: 'Fund',
              dataKey: 'fund'
            },
            {
              title: 'Amount',
              dataKey: 'data'
            }
          ],
          data,
          defaultSort: {
            field: 'date',
            ascending: true
          }
        }}
      />
    </DataLayout>
  )
}

export default RevenueByObjectCode
